document.addEventListener("DOMContentLoaded", () => {
    let doc = document;
    let sliders = doc.querySelectorAll('.text-image-content');
    sliders.forEach((slider) => {
        let objectSlider = new TextImageSlider(slider);
        objectSlider.init();
    });
});

class TextImageSlider {
    constructor(slider) {
        this.slider = slider;
        this.hasImages = !slider.classList.contains('text-image-content--without-images');
        this.wrap = slider.querySelector('.text-image-content__items')
        this.items = slider.querySelectorAll('.text-image-content__item');
        this.side = slider.getAttribute('data-side');
        this.itemsCount = !this.hasImages && window.innerWidth > 992 ? Math.round(this.items.length / 2) : this.items.length;
        this.index = 0;
        this.animate = false;
    }

    init() {
        document.documentElement.style.setProperty('--animate-duration', '0.8s');
        this.bindArrows();
        this.setHeight();
    }

    slide(direction) {
        let inImageClasses = [];
        let inContentClasses = [];
        let outImageClasses = [];
        let outContentClasses = [];
        if (window.innerWidth < 992) {
            inImageClasses = ['animate__animated', 'animate__fadeIn'];
            inContentClasses = ['animate__animated', 'animate__fadeIn'];

            outImageClasses = ['animate__animated', 'animate__fadeOut'];
            outContentClasses = ['animate__animated', 'animate__fadeOut'];
        } else {
            inImageClasses = ['animate__animated', (this.side == 'left' ? 'animate__fadeInLeft' : 'animate__fadeInRight')];
            inContentClasses = ['animate__animated', (this.side == 'left' ? 'animate__fadeInRight' : 'animate__fadeInLeft')];

            outImageClasses = ['animate__animated', (this.side == 'left' ? 'animate__fadeOutLeft' : 'animate__fadeOutRight')];
            outContentClasses = ['animate__animated', (this.side == 'left' ? 'animate__fadeOutRight' : 'animate__fadeOutLeft')];
        }

        if (this.animate) {
            return;
        }
        this.animate = true;
        let activeItem = this.items[this.index];

        if (direction == 'left') {
            this.index = (this.index - 1) < 0 ? this.itemsCount - 1 : (this.index - 1);
        } else if (direction == 'right') {
            this.index = (this.index + 1) > this.itemsCount - 1 ? 0 : (this.index + 1);
        }

        /* this.addImageClasses(activeItem, outImageClasses);
         activeItem.querySelector('.text-image-content__item-container').classList.add(...outContentClasses);

         let nextItem = this.items[this.index];
         this.removeImageClasses(nextItem,inImageClasses);
         nextItem.querySelector('.text-image-content__item-container').classList.remove(...inContentClasses);*/


        let that = this;
        that.wrap.style.left = (that.index * -100) + '%';
        setTimeout(function () {
            /*that.addImageClasses(nextItem, inImageClasses);
            nextItem.querySelector('.text-image-content__item-container').classList.add(...inContentClasses);

            that.removeImageClasses(activeItem,outImageClasses);
            activeItem.querySelector('.text-image-content__item-container').classList.remove(...outContentClasses);*/
            that.animate = false;
        }, 400);

        /*setTimeout(function () {
        }, 1600);*/
    }

    addImageClasses(item, classesData) {
        let images = item.querySelectorAll('.text-image-content__image');
        images.forEach(function (node) {
            node.classList.add(...classesData);
        })
    }

    removeImageClasses(item, classesData) {
        let images = item.querySelectorAll('.text-image-content__image');
        images.forEach(function (node) {
            node.classList.remove(...classesData);
        })
    }

    bindArrows() {
        let buttons = this.slider.querySelectorAll('.text-image-content__buttons');
        buttons.forEach((buttonContainer) => {
            let leftArrow = buttonContainer.querySelector('.left');
            let rightArrow = buttonContainer.querySelector('.right');

            leftArrow.addEventListener('click', () => {
                this.slide('left');
            });
            rightArrow.addEventListener('click', () => {
                this.slide('right');
            });

        })
    }

    setHeight() {
        let contents = this.wrap.querySelectorAll('.text-image-content__item-content');

        if (contents.length <= 1) {
            return;
        }

        let maxHeight = 0;
        contents.forEach((content) => {
            if (maxHeight < content.clientHeight) {
                maxHeight = content.clientHeight;
            }
        });
        contents.forEach((content) => {
            content.style.height = maxHeight + 'px';
        });
    }
}
